// Modules
import React from "react"; 
import moment from "moment";

// Interfaces
import ContractToolTip from 'Interfaces/ContractToolTipInterface';
import { Tip } from "Interfaces/TipInterface";

// Components
import ToolTip from 'Generic/ToolTip';
import { Position } from '../ToolTip';

// @ts-ignore
import { LocalizationContext } from 'react-localize';

type Props = {
    contract: ContractToolTip;
    position?: Position;
    useRefToPosition?: boolean;
};
class MvContractToolTip extends React.Component<Props, {}> {   
    constructor(props:Props) {
        super(props);
    }

    render() {
        // https://jira.iilg.com/secure/attachment/356213/Tool%20Tip%20View%20for%20Contract%20ID%27s.png
        // there are two user roles and two contract types which makes a total of 4 different views possible
        // User Roles = "VOA" or "Owner"
        // Type = "Weeks" or "Points"

        const { localize } = this.context;
        const { contract } = this.props;
        const startDate = moment(contract.startDate).format('M/D/YYYY')
        const end = contract.endDate;
        const endDate = end ? moment(end).format('M/D/YYYY') : "";
        const contractPoints = contract.points ? contract.points.toLocaleString() : '';
        const pointsInfo = (endDate ? startDate + " - " + endDate + " - " : "") + contractPoints;
        const firstUsageYear = localize("static.content.ayp-tooltip-first-usage-year");
        const contractOwners = localize("static.content.ayp-tooltip-contract-owners");

         // todo: get the real user Role - "VOA" or "Owner" ?
         // OR: it might be possible to get the api to return what the user is allowed to see
         // so then we won't have to worry about this part
        const userRole = (contract.contractId === "AS*6520" || contract.contractId === "41382" || contract.contractId === "NC*4132*07*B") ? "VOA" : "Owner";

        // Weeks - resort info
        const weeks = <>
            <p><b>{contract.resortName}</b></p>
            <p>{contract.roomType}, {contract.roomView} {contract.season}</p>
            <p>{firstUsageYear}: {contract.usageYear}</p>  
        </>

        // Points - point info..?
        //CE2RT1C-899 - 5. If contracts API gives owner details, show contract tooltip with more details
        const points = <>
            {(contract.ownershipDetails === null || contract.ownershipDetails === undefined || Object.keys(contract.ownershipDetails!).length === 0) ? 
            <>
                <p className="bold">{contract.contractType}</p>
                <p>{(endDate ? startDate + " - " + endDate + " - " + contractPoints : startDate)}</p>
                <p>{(!endDate ? contractPoints : "")}</p>
            </>
                :
                <>
                    <p className="bold">{contract.ownershipDetails!.resortName}</p>
                    <p>{contract.ownershipDetails!.roomDetails}</p>
                    <p>{firstUsageYear}: {contract.ownershipDetails!.firstYearUsage}</p>
                    <p>{pointsInfo}</p>
                </>}
            {/* <p>{pointsInfo}</p> */}
        </>

        // const points = <>
        //     <p className="bold">{contract.contractType}</p>
        //     <p>{pointsInfo}</p>
        // </>

        // Owners - list of owner names
        const owners = contract.owners && (contract.owners).map(function(owner, index){
            const info = [];
            index === 0 && info.push(<p>{contractOwners}:</p>);
            info.push(<p key={index}>{owner.name} ({owner.ownerId})</p>);
            return info;
        })

        let view = [];
        // determine if this contract is weeks or points
        let contractView = contract.typeName.toLowerCase() === "weeks" ? weeks : points;

        // only the "VOA" user role can see the list of owners - the "Owners" user role cannot
        let ownersView = owners && userRole.toLowerCase() === "voa" ?  owners : [];

        view.push(contractView);
        view.push(ownersView);

        // add the view to the Tip jsx
        const tooltip: [Tip] = [{
            label: "",
            desc: contract.contractId,
            jsx: view
        }]

        return (
            <div className="tool-tip-contract">
                <ToolTip useRefToPosition={this.props.useRefToPosition ? true : false} id={`mv-contract-tooltip-${contract.contractId}`} tabIndex={-1} tip={tooltip} position={this.props.position}>
                    {this.props.children}
                </ToolTip>
            </div>
        )
    }
}

MvContractToolTip.contextType = LocalizationContext;
export default MvContractToolTip